import { useEffect } from 'react';
import { ETestIds } from '../../../../constants/testIds';
import { setActiveMasterButton } from '../../../../redux/landingSlice';
import { useDispatch } from 'react-redux';
import { MortgageWrapperIdName } from '../../../../constants/common';
import { EFillApplicationStickyButtonType } from '../types';
import { useIsDesktop } from '../../../../hooks/common';

/**
 * Хук для управления отображением стики-кнопок.
 * В один момент может быть видна только одна кнопка.
 * */
export const useFillApplicationStickyButtons = (offersLength: number) => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();

  const listingIsSmall = offersLength > 0 && offersLength < 4;

  useEffect(() => {
    if (!isDesktop) {
      return;
    }

    const presentationBtn = document.querySelector(`[data-testid=${ETestIds.PresentationBtn}]`) as Element;
    const mortgageBlock = document.getElementById(MortgageWrapperIdName) as Element;

    if (!presentationBtn || !mortgageBlock) {
      return;
    }

    // Сбрасываем состояние при инициализации
    dispatch(setActiveMasterButton(null));

    const topButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            dispatch(setActiveMasterButton(null));
          } else {
            dispatch(setActiveMasterButton(EFillApplicationStickyButtonType.TOP));
          }
        });
      },
      {
        threshold: listingIsSmall ? 0.1 : 1,
        rootMargin: '-300px 0px',
      },
    );

    const bottomButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            /**
             * Проверяем, что пользователь не находится в самом верху страницы
             * */
            if (window.scrollY !== 0) {
              dispatch(setActiveMasterButton(EFillApplicationStickyButtonType.TOP));
            }
          } else {
            dispatch(setActiveMasterButton(EFillApplicationStickyButtonType.BOTTOM));
          }
        });
      },
      {
        threshold: 0,
        rootMargin: listingIsSmall ? '-400px' : '0px',
      },
    );

    topButtonObserver.observe(presentationBtn);
    bottomButtonObserver.observe(mortgageBlock);

    return () => {
      topButtonObserver.disconnect();
      bottomButtonObserver.disconnect();
    };
  }, [isDesktop, listingIsSmall, dispatch]);
};
